import { Route } from '@angular/router';

import { SilentRefreshComponent } from './auth/silent-refresh/silent-refresh.component';
import { ROUTES } from './definitions/constants/routes.constants';
import { appPortalGuard } from './guards/app-portal.guard';
import { appRoutingGuard } from './guards/app-routing.guard';
import { repEvolutionGuard } from './guards/rep-evolution.guard';
import { replenishmentGuard } from './guards/replenishment.guard';
import { PortalPageComponent } from './pages/portal-page/portal-page.component';

export const appRoutes: Array<Route> = [
  {
    path: ROUTES.MAIN,
    canActivate: [ appRoutingGuard ],
    pathMatch: 'full',
    children: []
  },
  {
    path: ROUTES.APP_PORTAL,
    canActivate: [ appPortalGuard ],
    component: PortalPageComponent
  },
  {
    path: ROUTES.REPLENISHMENT,
    canActivate: [ replenishmentGuard ],
    canActivateChild: [ replenishmentGuard ],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    loadChildren: () => import ('./pages/replenishment/replenishment.routes')
      .then(mod => mod.replenishmentRoutes)
  },
  {
    path: ROUTES.REP_EVOLUTION,
    canActivate: [ repEvolutionGuard ],
    loadChildren: () => import ('./pages/rep-evolution/rep-evolution.routes')
      .then(mod => mod.repEvolutionRoutes)
  },
  {
    path: ROUTES.SILENT_REFRESH,
    component: SilentRefreshComponent
  },
  {
    path: ROUTES.UNKNOWN,
    redirectTo: ROUTES.MAIN
  }
];
